import api from "../utils/apiUserTienda";

export const getPaises = async () => {
  const res = await api.get("/api/locacion/paises/obtener");
  return res.data;
};

export const getRegiones = async (paisId) => {
  const res = await api.get(`/api/locacion/regiones/obtener/${paisId}`);
  return res.data;
};

export const getCiudades = async (regionId) => {
  const res = await api.get(`/api/locacion/ciudades/obtener/${regionId}`);
  return res.data;
};
